/*
 * @Author: 759729757@qq.com 759729757@qq.com
 * @Date: 2022-12-23 23:23:54
 * @LastEditors: 759729757@qq.com 759729757@qq.com
 * @LastEditTime: 2022-12-30 10:23:35
 * @FilePath: \librarySym\src\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import axios from 'axios';
import Allbooks from '../data';

const basePath = window.bookSystemBasePath || 'http://localhost:3000';

// export let _base = 'https://wechat.studiosortie.com'; //Sortie
export let _base = basePath; //Planet


export const selectBooksAsPage = (keywords, offset) =>{
    var books;
    if(keywords){
        books = Allbooks.filter(book => book.name.indexOf(keywords) > -1);
    }else{
        books = Allbooks;
    }
    offset = offset || 0;

    var books = books.slice(offset*10, offset*10 + 10);
    console.log('data', offset);

    var data = {
        data: books
    }
    return data;
    return axios.get(
        `${_base}/selectBooksAsPage`,
        {
            params: 
            {
                keywords: keywords,
                offset: offset
            }
        }
    ).then(res=>
        res.data
    ); 
};
export const countBooks = keywords =>{
    var books;
    if(keywords){
        books = Allbooks.filter(book => book.name.indexOf(keywords) > -1);
    }else{
        books = Allbooks;
    }

    var data = {
        data: books.length
    }
    return data;

    return axios.get(
        `${_base}/countBooks`,
        {
            params: 
            {keywords: keywords}
        }
    ).then(res=>
        res.data
    ); 
};

export const updateUserAddress = params => { return axios.post(`${_base}/updateUserAddress`, params).then(res=>res.data); };






// WEBPACK FOOTER //
// ./src/api/index.js